import ContactUS from "@/components/contactUs";
import MetaComponent from "@/components/common/MetaComponent";
import { useEffect } from "react";
import { trackPageMount } from "@/utils/analytics";

const metadata = {
  title: "Hubzu | Contact-us",
};

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageMount({
      pageName: "contact_us_page_view",
      eventCategory: "Contact us Page",
      eventSource: "Contact us Page",
    });
  }, []);

  return (
    <>
      <MetaComponent meta={metadata} />
      <ContactUS />
    </>
  );
};

export default ContactUs;
